export default "__VITE_ASSET__Bkef2fKu__"